import ApiService from "./api.service";

class InteractiveService extends ApiService {

    getAvailableGuests() {
        return this.get("api/meeting/interactive/discussion/get-available-guests");
    }

    getUserPresences(sessionId) {
        return this.get(`api/meeting/interactive/presence/${sessionId}`);
    }

    getUserPartialPresences(sessionId) {
        return this.get(`api/meeting/interactive/presence/${sessionId}/partial`);
    }

    setUserPresence(sessionId, personId) {
        return this.put(`api/meeting/interactive/presence/${sessionId}/partial/${personId}`)
    }

    deleteUserPresence(sessionId, personId) {
        return this.delete(`api/meeting/interactive/presence/${sessionId}/partial/${personId}`)
    }

    getPresenceTimeList(sessionId) {
        return this.get(`api/meeting/interactive/presence-time/${sessionId}`);
    }

    saveUserPresences(sessionId, quorum, data) {
        return this.post(`Interactive/presence/${sessionId}/${quorum}`, data);
    }

    getCurrentRequestList(sessionId) {
        return this.get(`api/meeting/interactive/discussion/get-current-voice-request/${sessionId}`);
    }

    getActivePoint(sessionId) {
        return this.get(`api/meeting/interactive/activepoint/${sessionId}`);
    }

    addTimeForUserSpeaker(data) {
        return this.post(`api/meeting/interactive/addTimeForUserSpeaker`, data)
    }

    startVoting(data) {
        return this.put(`api/voting/interactive/startVoting`, data)
    }

    cancelVoting(data) {
        return this.put(`api/voting/interactive/cancelVoting`, data)
    }

    saveVoting(data) {
        return this.put(`api/voting/interactive/saveVoting`, data)
    }

    getVotingPartialResults(data) {
        return this.put(`api/voting/interactive/getVotingPartialResults`, data)
    }

    startCheckQuorum(data) {
        return this.put(`Interactive/startCheckQuorum`, data)
    }

    stopCheckQuorum(data) {
        return this.put(`Interactive/stopCheckQuorum`, data)
    }

    quorumResultsChanged(data) {
        return this.put(`Interactive/quorumResultsChanged`, data)
    }
}

export default new InteractiveService();
